import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	padding: 30px;
	align-items: center;
	flex-direction: column;
	gap: 30px;
`;

export const SearchBarWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 40px;
`;

export const ButtonsWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
`;
